export function msUntilExpiry(expiration: string): number {
  return new Date(expiration).getTime() - Date.now()
}

export function isTokenValid(
  token?: string,
  expiration?: string,
  minRemainingMs = 0,
): boolean {
  if (!token) return false
  if (!expiration) return true

  return msUntilExpiry(expiration) > minRemainingMs
}

export function bearerAuthConfig(token?: string) {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
}
